import PropTypes from 'prop-types';

// ==============================|| PRESET THEME - DEFAULT ||============================== //

const Default = (colors) => {
  const { red, gold, cyan, green, grey, volcano, magenta, purple, blue } = colors;

  const greyColors = {
    0: grey[0],
    50: grey[1],
    100: grey[2],
    200: grey[3],
    300: grey[4],
    400: grey[5],
    500: grey[6],
    600: grey[7],
    700: grey[8],
    800: grey[9],
    900: grey[10],
    A50: grey[15],
    A100: grey[11],
    A200: grey[12],
    A400: grey[13],
    A700: grey[14],
    A800: grey[16]
  };

  const contrastTextWhite = '#ffffff';
  const contrastTextDark = greyColors[900];

  return {
    primary: {
      lighter: red[0],
      100: red[1],
      200: red[2],
      light: red[3],
      400: red[4],
      main: red[5],
      dark: red[6],
      700: red[7],
      darker: red[8],
      900: red[9],
      contrastText: contrastTextWhite
    },
    secondary: {
      lighter: magenta[0],
      100: magenta[1],
      200: magenta[2],
      light: magenta[3],
      400: magenta[4],
      main: magenta[5],
      600: magenta[6],
      dark: magenta[7],
      800: magenta[8],
      darker: magenta[9],
      A100: magenta[0],
      A200: magenta[1],
      A300: magenta[2],
      contrastText: contrastTextWhite
    },
    error: {
      lighter: red[0],
      light: red[2],
      main: red[6],
      dark: red[7],
      darker: red[9],
      contrastText: contrastTextWhite
    },
    warning: {
      lighter: volcano[0],
      light: volcano[3],
      main: volcano[5],
      dark: volcano[7],
      darker: volcano[9],
      contrastText: contrastTextWhite
    },
    info: {
      lighter: purple[0],
      light: purple[3],
      main: purple[5],
      dark: purple[7],
      darker: purple[9],
      contrastText: contrastTextWhite
    },
    success: {
      lighter: green[0],
      light: green[3],
      main: green[5],
      dark: green[7],
      darker: green[9],
      contrastText: contrastTextWhite
    },
    grey: greyColors,
    blue: {
      lighter: blue[0],
      100: blue[1],
      200: blue[2],
      light: blue[3],
      400: blue[4],
      main: blue[5],
      dark: blue[6],
      700: blue[7],
      darker: blue[8],
      900: blue[9],
      contrastText: contrastTextWhite
    }
  };
};

Default.propTypes = {
  colors: PropTypes.object
};

export default Default;
